import { useState } from 'react';
import styled from 'styled-components';

import { TermWithType } from './hooks/useSaleListHooks';
import useKeywordSearch from './hooks/useKeywordSearch';
import usePeriodFilter from './hooks/usePeriodFilter';

import { useQueryGetHostDashBoard } from 'containers/Menu/graphQL/hooks/useQueryGetHostDashBoard';

import { OrderConnection, OrderState } from 'types/api';

import SaleHeader from './SaleHeader';
import DetailSearchModal from './DetailSearchModal';
import SearchSection from './SearchSection';
import PaymentState from './PaymentState';
import SoldProductContent from './SoldProductContent';
import OverviewDataModal from './OverviewDataModal';
import { OrderFilterInput } from './graphQL/types';
import { HEADER_HEIGHT } from 'constants/style';
const ListSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  flex-basis: 66%;

  position: relative;

  max-width: 790px;
  width: 100%;
  height: calc(100vh - ${HEADER_HEIGHT}px);
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (max-width: 767px) {
    flex-basis: 100%;
  }
`;

export type FilterStatus = 'all' | 'payment' | 'cancel';

interface Props {
  isMobile: boolean;
  selectedSaleId: string | null;
  handleSelectSaleId: (id: string) => void;
  orderItems: OrderConnection;
  isLoading: boolean;
  orderFilterInput: OrderFilterInput;
  isOpenCountFilter: boolean;
  termWithType: TermWithType | null;
  handleSetFilterValue: (key: string, value: any) => void;
  handleSetOrderFilterInput: (key: string, value: any) => void;
  handleIsOpenCountFilter: () => void;
  handleRefreshData: () => void;
  selectedOrderId: string | null;
  selectedScheduleIds: string | null;
}

function SaleProductSection({
  isMobile,
  selectedSaleId,
  handleSelectSaleId,
  selectedOrderId,
  selectedScheduleIds,
  ...restProps
}: Props) {
  const [selectedFilterStatus, setSelectedFilterStatus] =
    useState<FilterStatus>('all');

  const [isOverviewModalOpen, setIsOverviewModalOpen] = useState(false);

  const {
    orderItems,
    isLoading,
    orderFilterInput,
    isOpenCountFilter,
    termWithType,
    handleSetFilterValue,
    handleSetOrderFilterInput,
    handleIsOpenCountFilter,
    handleRefreshData,
    // isOpenSearchModal,
    // selectedId,
    // filterValue,
    // isAcceptFilter, // 검색했는지 안했는지를 확인할 수 있는 값
    // deliveryData,
    // handleSetTermWithType,
    // setSelectedId,
    // setIsOpenSearchModal,
    // handleResetFilterValue,
    // setIsAcceptFilter,
  } = restProps;

  const handleOverviewModal = () => {
    setIsOverviewModalOpen(prev => !prev);
  };

  const { hostDashBoard } = useQueryGetHostDashBoard();

  const keywordSearch = useKeywordSearch({
    orderFilterInput,
    handleSetFilterValue,
    handleSetOrderFilterInput,
    termWithType,
    selectedOrderId,
    selectedScheduleIds,
  });

  const periodFilter = usePeriodFilter({
    orderFilterInput,
    handleSetOrderFilterInput,
  });

  const hasAppliedPeriodFilter = !!(
    orderFilterInput?.filter?.transactionTerm?.startedAt &&
    orderFilterInput?.filter?.transactionTerm?.endedAt
  );

  // 전체, 결제완료, 취소완료 조건 핸들러
  const handlePaymentState = (status: FilterStatus) => {
    const statusIn =
      status === 'payment'
        ? [OrderState.COMPLETED]
        : status === 'cancel'
        ? [OrderState.CANCELED]
        : null;

    handleSetOrderFilterInput('filter', {
      ...orderFilterInput.filter,
      statusIn,
    });

    setSelectedFilterStatus(status);
  };

  return (
    <ListSectionContainer>
      <SaleHeader
        hostDashBoard={hostDashBoard}
        handleDetailModal={periodFilter.handleDetailModal}
        handleOverviewModal={handleOverviewModal}
        hasAppliedPeriodFilter={hasAppliedPeriodFilter}
        isMobile={isMobile}
      />

      <SearchSection {...keywordSearch} isMobile={isMobile} />

      <PaymentState
        selectedFilterStatus={selectedFilterStatus}
        handlePaymentState={handlePaymentState}
        isMobile={isMobile}
      />

      <SoldProductContent
        orderItems={orderItems}
        isOpenCountFilter={isOpenCountFilter}
        orderFilterInput={orderFilterInput}
        handleSetOrderFilterInput={handleSetOrderFilterInput}
        handleIsOpenCountFilter={handleIsOpenCountFilter}
        isLoading={isLoading}
        selectedSaleId={selectedSaleId}
        handleSelectSaleId={handleSelectSaleId}
        handleRefreshData={handleRefreshData}
        isMobile={isMobile}
      />

      {periodFilter.isOpenDetailModal && (
        <DetailSearchModal
          isMobile={isMobile}
          orderFilterInput={orderFilterInput}
          {...periodFilter}
        />
      )}

      {isOverviewModalOpen && (
        <OverviewDataModal
          isMobile={isMobile}
          handleOverviewModal={handleOverviewModal}
          hostDashboard={hostDashBoard}
        />
      )}
    </ListSectionContainer>
  );
}

export default SaleProductSection;
